import { Globe, CreditCard, ShieldCheck, MessageCircle } from "lucide-react";

const ITEMS = [
  { icon: Globe, title: "OFW Assistance Desk", desc: "Dedicated support for Filipinos working abroad" },
  { icon: MessageCircle, title: "Easy Online Inquiry", desc: "Start everything from wherever you are" },
  { icon: CreditCard, title: "Flexible Payment Terms", desc: "OFW-friendly installment arrangements" },
  { icon: ShieldCheck, title: "Secure Property Titles", desc: "Your investment, protected for generations" },
];

export default function TrustBar() {
  return (
    <section className="bg-[#0C2340] py-14 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((item) => (
          <div key={item.title} data-testid={`trust-item-${item.title.toLowerCase().replace(/\s+/g, "-")}`} className="flex gap-4">
            <span className="shrink-0 w-11 h-11 rounded-full bg-[#C59B27]/15 flex items-center justify-center">
              <item.icon className="w-5 h-5 text-[#C59B27]" />
            </span>
            <div>
              <h3 className="text-white font-semibold text-sm">{item.title}</h3>
              <p className="text-white/60 text-sm mt-1">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
